import { Route, Routes, useParams } from "react-router-dom";
import { MdOutlineContentCopy } from "react-icons/md";

import { useCourse } from "api/hooks";
import { PageMain } from "components/molecules";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { routes } from "consts";
import { PaziaLoader } from "components/atoms";
import { PaziaBox, PaziaTab, PaziaTabs } from "components/atoms";
import { removeTrailingSlash } from "utils/urlUtils";
import { useState } from "react";
import { useToaster } from "utils";
import { clientAppUrl } from "../../branding";

export const CourseIntegrationsPage = () => {
  const { courseId } = useParams();
  const { loading: loadingCourse, data: course } = useCourse(Number(courseId));

  if (loadingCourse) return <PaziaLoader position="center" />;
  if (!course) return null;
  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Kursy", path: routes.COURSES },
          {
            title: [course.data.name, course.data.variant].filter(Boolean).join(" · "),
            path: routes.COURSES_MANAGE(course.data.id),
          },
          { title: "Integracje" },
        ]}
        headerText="Integracje"
      />

      <PaziaBox>
        <CourseIntegrationTabs courseId={courseId!} />
        <Routes>
          <Route path={""} element={<CourseWidgets courseGroupId={course.group.id} slug={course.data.slug} />} />
        </Routes>
      </PaziaBox>
    </PageMain>
  );
};

type CourseWidgetsProps = {
  slug: string;
  courseGroupId: number;
  clientHostname?: string;
};
const CourseWidgets = ({ clientHostname = clientAppUrl, slug, courseGroupId }: CourseWidgetsProps) => {
  return (
    <div>
      <WidgetPreview
        iFrameStyle="height: 25px"
        title="Cena kursu"
        url={clientHostname + `/widgets/course/price/${slug}`}
      />
      <WidgetPreview
        iFrameStyle="height: 35px; width: 135px;"
        title="Przycisk do zapisu"
        url={clientHostname + `/widgets/course/sign-in/${slug}`}
      />
      <WidgetPreview
        iFrameClassName="min-h-96 w-full"
        iFrameStyle="height:280px"
        title="Tabela edycji"
        url={clientHostname + `/widgets/course-group/editions/${courseGroupId}`}
      />
    </div>
  );
};

const WidgetPreview = ({
  title,
  url,
  iFrameClassName = "",
  iFrameStyle = "",
}: {
  title: string;
  url: string;
  iFrameClassName?: string;
  iFrameStyle?: string;
}) => {
  const { showInfo } = useToaster();
  const [iFrameCode] = useState(`<iframe style="${iFrameStyle}" class="${iFrameClassName}" src="${url}"></iframe>`);

  const copyCode = () => {
    navigator.clipboard.writeText(iFrameCode);
    showInfo("Kod skopiowany do schowka");
  };
  return (
    <div className="relative">
      <h2 className="mb-2 mt-4 text-lg font-semibold">{title}</h2>
      <MdOutlineContentCopy
        size={24}
        className="absolute right-1 top-11 cursor-pointer hover:text-slate-600"
        onClick={copyCode}
      />
      <div
        className={`rounded border bg-gray-100 p-4 ${iFrameClassName}`}
        dangerouslySetInnerHTML={{
          __html: iFrameCode,
        }}
      ></div>
    </div>
  );
};

const CourseIntegrationTabs = ({ courseId }: { courseId: string }) => {
  const checkLocationPathName = (path: string) => {
    return removeTrailingSlash(location.pathname) === removeTrailingSlash(path);
  };
  const tabs: PaziaTab[] = [
    {
      name: "Widgety",
      active: checkLocationPathName(routes.COURSES_MANAGE_NESTED.INTEGRATIONS(courseId)),
      link: routes.COURSES_MANAGE_NESTED.INTEGRATIONS(courseId),
    },
  ];
  return <PaziaTabs tabs={tabs} className="mb-4" />;
};
